import {IntegratedFiltering} from "@devexpress/dx-react-grid";
import _ from 'lodash';

/** CONSTANT **/
export const COL_TYPE = {
	TEXT : "TEXT",
	NUMBER : "NUMBER",
	NULLABLE_NUMBER : "NULLABLE_NUMBER",
	DATE : "DATE",
	EDIT : "EDIT",
	EDIT_NUM : "EDIT_NUM",
	EDIT_NULLABLE_NUM : "EDIT_NULLABLE_NUM",
	EDIT_SELECT : "EDIT_SELECT",
	EDIT_DATE : "EDIT_DATE",
	BUTTON : "BUTTON",
	CHECK : "CHECK",
	CLICK_TEXT : "CLICK_TEXT",
	CLICK_NUMBER : "CLICK_NUMBER",
	DELETE_ROW_BUTTON : "DELETE_ROW_BUTTON"
}

export const FILTER_MESSAGE = {
	filterPlaceholder: "絞り込み",
	contains: "～を含む",
	notContains: "～を含まない",
	startsWith: "～から始まる",
	endsWith: "～で終わる",
	equal: "等しい",
	notEqual: "等しくない",
	greaterThan: "～より多い",
	greaterThanOrEqual: "以上",
	lessThan: "～より小さい",
	lessThanOrEqual: "以下",
	month: "月が同じ"
}

export const TABLE_MESSAGE = {
	noData : "データなし"
};
export const PAGE_MESSAGE = {
	rowsPerPage : "表示件数",
	info : "{from} - {to} 件 / {count} 件中"
};

export const NUMBER_FILTER_OPERATIONS = [
	'equal',
	'notEqual',
	'greaterThan',
	'greaterThanOrEqual',
	'lessThan',
	'lessThanOrEqual'
]

export const DATE_FILTER_OPERATIONS = [
	'month',
	'contains',
	'startsWith',
	'endsWith'
]

/** STYLE **/

export const tableStyleBase = {
	tableHeader: {
		'& thead': {
			backgroundColor:'rgba(64,186,208,0.05)'
		},
		'& thead tr th' : {
			textAlign: 'left !important'
		},
		'& thead tr th div > span' : {
			flexDirection: 'inherit !important'
		},
		'& tbody tr:hover td': {
			backgroundColor:'rgba(200,200,200,0.1)'
		},
		'& tbody tr.isHighLight td': {
			backgroundColor:'rgba(200,200,200,0.3)'
		},
		'& tbody tr.isHighLight2 td': {
			backgroundColor:'rgba(255,242,204,0.3)'
		},
		'& tbody tr.isColorY td': {
			backgroundColor:'#fff8e1'
		},
		'& tbody tr.isColorM td': {
			backgroundColor:'#ffcdd2'
		},
		'& tbody tr.isColorC td': {
			backgroundColor:'#e0f7fa'
		},
		'& tbody tr.isColorG td': {
			backgroundColor:'#dcedc8'
		},
		'& tbody tr.isDeleted td': {
			backgroundColor:'rgba(200,200,200,0.6)'
		},
		'& tbody tr td.isSelectionReplaceButton': {
			position:'relative',
			overflow:'visible',
		},
		'& tbody tr td.isSelectionReplaceButton button': {
			position:'absolute',
			top:8,
			left:-50,
			minWidth:'54px !important'
		}
	},
};

export const tableStyle = (tableStyleBase);


/** METHODS **/
export const getRowId = row => row.id;

export function getColumnInfo(columns){
	return columns.map((row)=>{
		return {name:row.name, title:row.title}
	})
}
export function getColumnWidth(columns){
	return columns.map((row)=>{
		return {columnName:row.name, width:row.width}
	})
}
export function getColumnAlign(columns){
	return columns.map((row)=>{
		return {columnName:row.name, align:(row.align) ? row.align : 'left' }
	})
}
export function getColumnFilterDisabled(columns){
	return columns.map((row)=>{
		return {columnName:row.name, filteringEnabled:(row.filteringEnabled !== undefined) ? row.filteringEnabled : true }
	})
}

export function getColumnSortingDisabled(columns){
	return columns.map((row)=>{
		return {columnName:row.name, sortingEnabled:(row.sortingEnabled !== undefined) ? row.sortingEnabled : true }
	})
}

export function getNumberColumns(columns){
	let ret = [];
	columns.forEach((column)=> {
		if (column.type === COL_TYPE.NUMBER ||
			column.type === COL_TYPE.NULLABLE_NUMBER ||
			column.type === COL_TYPE.EDIT_NUM ||
			column.type === COL_TYPE.EDIT_NULLABLE_NUM ||
			column.type === COL_TYPE.CLICK_NUMBER
		) {
			ret.push(column.name);
		}
	});
	return ret;
}

export function getDateColumns(columns){
	let ret = [];
	columns.forEach((column)=> {
		if (column.type === COL_TYPE.DATE ||
			column.type === COL_TYPE.EDIT_DATE
		) {
			ret.push(column.name);
		}
	});
	return ret;
}

export function getDateFilteringColumnExtensions(columns){
	let ret = [];
	columns.forEach((column)=> {
		if (column.type === COL_TYPE.DATE ||
			column.type === COL_TYPE.EDIT_DATE
		) {
			ret.push({
				columnName:column.name,
				predicate:dateFilterPredicate
			});
		}
	});
	return ret;
}

function dateFilterPredicate (value, filter, row){
	if (!filter.value.length) return true;
	if (filter && filter.operation === 'month') {
		const month = parseInt(value.split(/[-\/]/)[1], 10);
		return month === parseInt(filter.value, 10);
	}

	return IntegratedFiltering.defaultPredicate(value, filter, row);
}

export function getSuggestionFilteringColumnExtensionsForMaster(suggestions){
	let ret = [];
	Object.keys(suggestions).forEach((name)=> {
		ret.push({
			columnName:name,
			predicate:suggestionFilterPredicate
		});
	});
	return ret;
}
export function getSelectableFilteringColumnExtensionsForMaster(selectable){
	let ret = [];
	Object.keys(selectable).forEach((name)=> {
		ret.push({
			columnName:name,
			predicate:(value, filter, row)=>{
				return selectableFilterPredicate(value, filter, row, selectable[name])
			}
		});
	});
	return ret;
}


function suggestionFilterPredicate (value, filter, row){
	if (!filter.value.length) return true;
	if(!value) {
		value = {
			name: "",
			label: ""
		}
	}
	if (filter) {
		switch(filter.operation){
			case "contains":
				return value.label.match(escapeRegExp(filter.value));
			case "notContains":
				return !value.label.match(escapeRegExp(filter.value));
			case "startsWith":
				return String(value.value).startsWith(filter.value) || String(value.name).startsWith(filter.value);
			case "endsWith":
				return String(value.value).endsWith(filter.value) || String(value.name).endsWith(filter.value);
			case "equal":
				return value.value === filter.value || value.name === filter.value;
			case "notEqual":
				return value.value !== filter.value && value.name !== filter.value;
			default:
				return IntegratedFiltering.defaultPredicate(value, filter, row);
		}

	}

	return IntegratedFiltering.defaultPredicate(value, filter, row);
}

const reRegExp = /[\\^$.*+?()[\]{}|]/g,
	reHasRegExp = new RegExp(reRegExp.source);

function escapeRegExp(string) {
	return (string && reHasRegExp.test(string))
		? string.replace(reRegExp, '\\$&')
		: string;
}

function selectableFilterPredicate (value, filter, row, selectable){
	if (!filter.value.length) return true;
	const checkValueArray = _.filter(selectable,{value:value});
	if(checkValueArray.length === 0) return true;
	const checkValue = checkValueArray[0];

	if (filter) {
		switch(filter.operation){
			case "contains":
				return String(checkValue.name).match(filter.value);
			case "notContains":
				return !String(checkValue.name).match(filter.value);
			case "startsWith":
				return String(checkValue.name).startsWith(filter.value);
			case "endsWith":
				return String(checkValue.name).endsWith(filter.value);
			case "equal":
				return String(checkValue.name) === filter.value;
			case "notEqual":
				return String(checkValue.name) !== filter.value;
			default:
				return IntegratedFiltering.defaultPredicate(value, filter, row);
		}
	}

	return IntegratedFiltering.defaultPredicate(value, filter, row);
}

export function getSuggestionSortingExtensions(suggestions){
	const compareSuggestion = (a,b) =>{
		const priorityA = a.value;
		const priorityB = b.value;
		if (priorityA === priorityB) {
			return 0;
		}
		return (priorityA < priorityB) ? -1 : 1;
	}

	let ret = [];
	Object.keys(suggestions).forEach((name)=> {
		ret.push({
			columnName:name,
			compare:compareSuggestion
		});
	});
	return ret;

}

export function getErrors(rows,columns){
	return rows.map(row=>getRowError(row,columns));
}
export function getRowError(row,columns){
	let errorRow = {}
	let hasError = false;
	columns.forEach(column=>{
		if(!row[column]){
			errorRow[column] = "必須入力"
			hasError = true;
		}
		else{
			errorRow[column] = '';
		}
	})
	if(hasError) errorRow["hasError"] = true;
	return errorRow;
}

export function getRowIndexFromId(rows,id){
	return _.findIndex(rows,{'id':id});
}

export function getError(index,errors,column){
	if(!errors[index]) return '';
	if(!errors[index][column]) return '';
	return errors[index][column];
}



// WEBPACK FOOTER //
// ./src/common/utils/tables.js